import {Component} from '@angular/core';
import TimeOffPopupComponent from "../../time-off-popup.component";
import {
    AccessType,
    ChangePersonalTimeStatusCommand,
    CreatePersonalTimeCommand,
    EmployeeDto, PermissionType,
    PersonalTimesGridViewDto,
    TimeOffStatus
} from "@services";
import {AsyncPipe} from "@angular/common";
import {
    DxDateBoxComponent,
    DxFormComponent,
    DxTextAreaComponent,
    DxValidatorComponent
} from "devextreme-angular";
import {DxiItemComponent, DxiValidationRuleComponent} from "devextreme-angular/ui/nested";
import {PicturedItemSelectBoxComponent} from "../../../../../components";
import {TimeOffRequestModalComponent} from "../../time-off-request-modal/time-off-request-modal.component";
import moment from "moment/moment";
import {FormatDurationPipe} from "../../../../../pipes/format-duration.pipe";

@Component({
    selector: 'app-personal-time-popup',
    imports: [
        AsyncPipe,
        DxFormComponent,
        DxTextAreaComponent,
        DxValidatorComponent,
        DxiItemComponent,
        DxiValidationRuleComponent,
        PicturedItemSelectBoxComponent,
        TimeOffRequestModalComponent,
        DxDateBoxComponent,
        FormatDurationPipe
    ],
    templateUrl: './personal-time-popup.component.html',
    styleUrl: './personal-time-popup.component.scss',
})
export class PersonalTimePopupComponent extends TimeOffPopupComponent<PersonalTimesGridViewDto> {
    onSave() {
        let createPersonalTimeCommand = new CreatePersonalTimeCommand({
            requestedDate: this.formData.requestedDate,
            requestedStartTime: this.formData.requestedStartTime,
            requestedEndTime: this.formData.requestedEndTime,
            userId: this.formData.employee.id,
            description: this.formData.description
        });

        this.timeOffClient.createPersonalTime(createPersonalTimeCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    };

    protected get personalTimeRequested(): number | null {
        if (this.formData.requestedStartTime && this.formData.requestedEndTime) {
            const start = moment(this.formData.requestedStartTime, 'HH:mm');
            const end = moment(this.formData.requestedEndTime, 'HH:mm');

            if (end.isBefore(start)) return null;

            const duration = moment.duration(end.diff(start));
            return duration.asMinutes();
        }
        return null;
    }

    onStartTimeChanged(e: any) {
        this.formData.requestedEndTime = e.value;
    }

    async loadData() {
        if (this.request) {
            this.formData = new PersonalTimesGridViewDto();
            this.formData.init(this.request);
        } else {
            this.formData = new PersonalTimesGridViewDto();
            this.formData.init({
                employee: this.canShowInSelectBox ? new EmployeeDto({id: this.auth.userId}) : new EmployeeDto()
            });
        }
        this.employeeId.next(this.formData.employee.id);
    }

    changeStatus(status: TimeOffStatus) {
        let changeStatusCommand = new ChangePersonalTimeStatusCommand({
            id: this.formData.id,
            status: status
        });

        this.timeOffClient.changePersonalTimeStatus(changeStatusCommand).subscribe({
            next: () => this.handleSuccess(),
            error: (errors) => this.handleError(errors)
        });
    }

    protected override get canApprove(): boolean {
        return super.canApprove && this.auth.checkPermission(PermissionType.PersonalTimeRequests, AccessType.Manage);
    };

    protected override get canDecline(): boolean {
        return super.canDecline && this.auth.checkPermission(PermissionType.PersonalTimeRequests, AccessType.Manage);
    };

    protected get canEditEmployee(): boolean{
        return super.canEditEmployee && this.auth.checkPermission(PermissionType.PersonalTimeRequests, AccessType.Manage);
    }
}
